import React from "react";
import { Checkbox } from "antd";
import { Icon } from "Components";
import Icons from "Components/Icon/Icons";

interface Props {
    title: string;
    description: string;
    iconType: keyof typeof Icons;
    isChecked: boolean;
    onToggle: () => void;
}

const RecipientItem: React.FC<Props> = ({
    title,
    description,
    iconType,
    isChecked,
    onToggle,
}) => {

    return (
        <div className="phishing-step3__role-item" onClick={onToggle}>
            <Checkbox checked={isChecked} onChange={onToggle} onClick={(e) => e.stopPropagation()} />
            <div className="phishing-step3__role-info">
                <div className="phishing-step3__role-title">
                    <Icon type={iconType} />
                    <span className="phishing-step3__role-text">{title}</span>
                </div>
                <span className="phishing-step3__role-desc">{description}</span>
            </div>
        </div>
    );
}

export default RecipientItem;